import React, { useState } from 'react'
import { motion } from 'framer-motion'
import YouTube from 'react-youtube'
import { ChevronLeft, ChevronRight, Calendar, Play, Users, Clock, Eye, Heart, Share2, ExternalLink, Music, Film, Headphones, Mic2, Ticket, MapPin, CalendarDays, ZoomIn, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'


const Worship = () => {
  const [selectedEvent, setSelectedEvent] = useState(0)
  const [currentVideoPage, setCurrentVideoPage] = useState(1)
  const [likedVideos, setLikedVideos] = useState({})
  const [currentMonth, setCurrentMonth] = useState(new Date())
  const [selectedImage, setSelectedImage] = useState(null)
  const videosPerPage = 6
  const { t } = useTranslation()

  // Données des photos du concert
  const concertImages = [
  {
    id: 1,
    src: "/assets/images/vert.jpg",
    alt: "Concert DEEPER IN HIS PRESENCE - Scène principale",
    caption: "Scène principale - DEEPER IN HIS PRESENCE",
    orientation: "horizontal"
  },
  {
    id: 2,
    src: "/assets/images/hor.jpg",
    alt: "Concert DEEPER IN HIS PRESENCE - Adoration",
    caption: "Moments d'adoration",
    orientation: "vertical"
  }
];

  // Fonction pour ouvrir l'image en plein écran (zoom)
  const openImageZoom = (image) => {
    setSelectedImage(image)
    document.body.style.overflow = 'hidden'
  }

  // Fonction pour fermer le zoom
  const closeImageZoom = () => {
    setSelectedImage(null)
    document.body.style.overflow = 'auto'
  }

  // VIDÉOS DESAI WILONDJA 
  const youtubeVideos = [
    {
      id: "6dwoK2V_CC4", 
      title: t('worship.videos.intimacy.title'),
      description: t('worship.videos.intimacy.description'),
      duration: "5:32",
      views: "16k",
      date: "2025-06-15",
      category: t('worship.categories.worship'),
      tags: [
        t('worship.tags.adoration'),
        t('worship.tags.jesus'),
        t('worship.tags.intimacy')
      ],
      channel: t('worship.channel')
    },
    {
      id: "yQvVgGuFl-Y",
      title: t('worship.videos.algae.title'),
      description: t('worship.videos.algae.description'),
      duration: "4:15",
      views: "3K",
      date: "2023-02-28",
      category: t('worship.categories.meditation'),
      tags: [
        t('worship.tags.meditation'),
        t('worship.tags.power'),
        t('worship.tags.grace')
      ],
      channel: t('worship.channel')
    },
    {
      id: "C0C0RY7iLdI",
      title: t('worship.videos.love.title'),
      description: t('worship.videos.love.description'),
      duration: "6:45",
      views: "2.1k",
      date: "2021-04-10",
      category: t('worship.categories.adoration'),
      tags: [
        t('worship.tags.love'),
        t('worship.tags.grace'),
        t('worship.tags.adoration')
      ],
      channel: t('worship.channel')
    }
  ]

  const liveSessions = [
    {
      title: t('worship.sessions.coffee.title'),
      date: t('worship.sessions.coffee.date'),
      time: t('worship.sessions.coffee.time'),
      description: t('worship.sessions.coffee.description'),
      type: t('worship.sessions.coffee.type'),
      youtubeLink: "https://youtube.com/@ecoledadorationdesjeunes?si=ytJrx6POn5arGyJh",
      speaker: t('worship.sessions.coffee.speaker'),
      duration: t('worship.sessions.coffee.duration'),
      icon: <Headphones className="w-6 h-6" />
    },
    {
      title: t('worship.sessions.night.title'),
      date: t('worship.sessions.night.date'),
      time: t('worship.sessions.night.time'),
      description: t('worship.sessions.night.description'),
      type: t('worship.sessions.night.type'),
      youtubeLink: "https://youtube.com/@ecoledadorationdesjeunes?si=ytJrx6POn5arGyJh",
      speaker: t('worship.sessions.night.speaker'),
      duration: t('worship.sessions.night.duration'),
      location: t('worship.sessions.night.location'),
      icon: <Music className="w-6 h-6" />
    },
    {
      title: t('worship.sessions.morning.title'),
      date: t('worship.sessions.morning.date'),
      time: t('worship.sessions.morning.time'),
      description: t('worship.sessions.morning.description'),
      type: t('worship.sessions.morning.type'),
      youtubeLink: "https://youtube.com/@ecoledadorationdesjeunes?si=ytJrx6POn5arGyJh",
      speaker: t('worship.sessions.morning.speaker'),
      duration: t('worship.sessions.morning.duration'),
      icon: <Mic2 className="w-6 h-6" />
    }
  ]

  // Pagination
  const totalPages = Math.ceil(youtubeVideos.length / videosPerPage)
  const currentVideos = youtubeVideos.slice(
    (currentVideoPage - 1) * videosPerPage,
    currentVideoPage * videosPerPage
  )

  const opts = {
    height: '390',
    width: '100%',
    playerVars: {
      autoplay: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0
    },
  }

  const handleVideoClick = (videoId) => {
    const videoUrl = `https://youtu.be/${videoId}`
    window.open(videoUrl, '_blank', 'noopener,noreferrer')
  }

  const toggleLike = (videoId) => {
    setLikedVideos(prev => ({
      ...prev,
      [videoId]: !prev[videoId]
    }))
  }

  const handleShareVideo = (videoId, title) => {
    const url = `https://youtu.be/${videoId}`
    if (navigator.share) {
      navigator.share({
        title: t('worship.share.title', { title: title }),
        text: t('worship.share.text', { title: title }),
        url: url
      })
    } else {
      navigator.clipboard.writeText(url)
      alert(t('worship.share.copied'))
    }
  }

  const onPlayerReady = (event) => {
    event.target.pauseVideo()
  }

  return (
    <div className="min-h-screen bg-black text-white pt-24">
      {/* Hero Section */}
      <section className="relative overflow-hidden py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black z-10"></div>
        <div 
          className="absolute inset-0 z-0 opacity-20"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        
        <div className="container mx-auto px-4 relative z-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-600/20 to-yellow-800/20 rounded-2xl flex items-center justify-center border border-yellow-500/30">
                <Music className="w-8 h-8 text-yellow-600" />
              </div>
              <h1 className="text-5xl md:text-7xl font-bold font-serif">
                {t('worship.title')} <span className="text-yellow-600">{t('worship.titleHighlight')}</span>
              </h1>
            </div>
            <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed max-w-3xl mx-auto">
              {t('worship.subtitle')}
            </p>
          </motion.div>
        </div>
      </section>

      {/* ===== SECTION CONCERT DEEPER IN HIS PRESENCE ===== */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="max-w-7xl mx-auto"
          >
            {/* En-tête du concert */}
            <div className="text-center mb-12">
              <div className="inline-block px-4 py-1 bg-yellow-600/20 border border-yellow-500/30 rounded-full text-yellow-500 text-sm font-medium mb-4">
                🎵 ÉVÉNEMENT SPÉCIAL
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-serif mb-4">
                Un concert Gospel <span className="text-yellow-600">« DEEPER IN HIS PRESENCE »</span>
              </h2>
              <p className="text-lg md:text-xl text-gray-300 italic">
                A Worship Experience – Drawing Closer to God
              </p>
            </div>

            {/* Grille responsive : change d'ordre sur mobile */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
              {/* Colonne Texte - Passe en bas sur mobile */}
              <div className="space-y-6 order-2 lg:order-1">
                <p className="text-gray-300 text-base md:text-lg leading-relaxed">
                  Rejoignez Esaïe Wilondja pour une soirée spéciale d'adoration, de communion et de présentation officielle du livre <span className="text-yellow-500 font-semibold">Intimacy with Jesus</span>.
                </p>

                {/* Infos pratiques */}
                <div className="bg-gray-900/50 rounded-2xl p-4 md:p-6 border border-gray-800 space-y-4">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-yellow-600/20 rounded-xl flex items-center justify-center border border-yellow-500/30 flex-shrink-0">
                      <CalendarDays className="w-5 h-5 md:w-6 md:h-6 text-yellow-600" />
                    </div>
                    <div>
                      <p className="text-xs md:text-sm text-gray-400">Date</p>
                      <p className="text-sm md:text-base text-white font-semibold">Samedi 29 août 2026 – 17h00</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-yellow-600/20 rounded-xl flex items-center justify-center border border-yellow-500/30 flex-shrink-0">
                      <MapPin className="w-5 h-5 md:w-6 md:h-6 text-yellow-600" />
                    </div>
                    <div>
                      <p className="text-xs md:text-sm text-gray-400">Lieu</p>
                      <p className="text-sm md:text-base text-white font-semibold">Hyllie Park Kyrkan, Malmö</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-yellow-600/20 rounded-xl flex items-center justify-center border border-yellow-500/30 flex-shrink-0">
                      <Ticket className="w-5 h-5 md:w-6 md:h-6 text-yellow-600" />
                    </div>
                    <div>
                      <p className="text-xs md:text-sm text-gray-400">Entrée</p>
                      <p className="text-sm md:text-base text-white font-semibold">
                        Entrée gratuite sur réservation uniquement
                      </p>
                    </div>
                  </div>
                </div>

                {/* Boutons */}
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="https://www.eventbrite.com/e/deeper-in-his-presence-worship-concert-book-launch-biljetter-1990692224030"
                    className="inline-flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white rounded-xl font-semibold hover:shadow-2xl hover:shadow-yellow-500/20 hover:scale-105 transition-all duration-300 text-sm md:text-base"
                  >
                    <Ticket className="w-4 h-4 md:w-5 md:h-5" />
                    Réserver mon billet gratuit
                  </a>
                  <a
                    href="https://youtube.com/@esaie_wilondja?si=5Wou6bCZ8Lide8cv"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 bg-red-600/20 border border-red-500/30 text-white rounded-xl font-semibold hover:bg-red-600/30 transition-all duration-300 text-sm md:text-base"
                  >
                    <Play className="w-4 h-4 md:w-5 md:h-5" />
                    Regarder en direct
                  </a>
                </div>

                <p className="text-xs md:text-sm text-gray-500 mt-2">
                  📺 Le concert sera également diffusé en direct sur notre chaîne YouTube.
                </p>

                <div className="mt-4 md:mt-6 p-4 bg-yellow-600/10 border border-yellow-500/20 rounded-xl">
                  <p className="text-yellow-400 font-medium text-center text-sm md:text-base">
                    ✨ Vous êtes précieux. Bienvenue dans Sa présence !
                  </p>
                </div>
              </div>

              {/* Colonne Photos - Passe en haut sur mobile */}
              <div className="order-1 lg:order-2 space-y-4">
                {/* Photo Horizontale (Grande) */}
                <motion.div 
                  className="relative overflow-hidden rounded-2xl border border-gray-800 group cursor-pointer"
                  whileHover={{ scale: 1.02 }}
                  transition={{ duration: 0.3 }}
                  onClick={() => openImageZoom(concertImages[0])}
                >
                  <img
                    src={concertImages[0].src}
                    alt={concertImages[0].alt}
                    className="w-full h-auto max-h-[400px] md:max-h-[500px] object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3 md:p-4">
                    <p className="text-white text-sm md:text-base font-medium">{concertImages[0].caption}</p>
                  </div>
                </motion.div>

                {/* Deux photos verticales en bas */}
                <div className="grid grid-cols-2 gap-4">
                  <motion.div 
                    className="relative overflow-hidden rounded-2xl border border-gray-800 group cursor-pointer"
                    whileHover={{ scale: 1.02 }}
                    transition={{ duration: 0.3 }}
                    onClick={() => openImageZoom(concertImages[1])}
                  >
                    <img
                      src={concertImages[1].src}
                      alt={concertImages[1].alt}
                      className="w-full h-[180px] md:h-[280px] object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-2 md:p-3">
                      <p className="text-white text-xs md:text-sm font-medium">{concertImages[1].caption}</p>
                    </div>
                  </motion.div>

                  {/* Carte invitation - remplace la 3ème photo */}
                  <div className="relative overflow-hidden rounded-2xl border border-gray-800 bg-gradient-to-br from-yellow-900/30 to-black/80 flex items-center justify-center p-4 md:p-6 min-h-[180px] md:min-h-[280px]">
                    <div className="text-center">
                      <div className="w-10 h-10 md:w-14 md:h-14 bg-yellow-600/20 rounded-full flex items-center justify-center mx-auto mb-2 md:mb-3 border border-yellow-500/30">
                        <Music className="w-5 h-5 md:w-7 md:h-7 text-yellow-600" />
                      </div>
                      <p className="text-gray-300 text-xs md:text-sm font-medium">Venez vivre</p>
                      <p className="text-yellow-500 text-sm md:text-base font-bold">cette expérience</p>
                      <p className="text-yellow-500 text-sm md:text-base font-bold">unique</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ===== MODAL DE ZOOM PLEIN ÉCRAN ===== */}
      {selectedImage && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[1000] bg-black/95 backdrop-blur-lg flex items-center justify-center p-4"
          onClick={closeImageZoom}
        >
          <button
            onClick={closeImageZoom}
            className="absolute top-4 right-4 z-10 p-3 bg-white/10 hover:bg-white/20 rounded-full transition-colors"
          >
            <X className="w-6 h-6 md:w-8 md:h-8 text-white" />
          </button>

          <div className="relative max-w-7xl max-h-[90vh] w-full h-full flex items-center justify-center">
            <motion.img
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", damping: 25 }}
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="w-full h-full object-contain rounded-2xl"
              onClick={(e) => e.stopPropagation()}
            />
            
            {/* Légende en bas */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 md:p-6">
              <p className="text-white text-sm md:text-xl font-medium text-center">
                {selectedImage.caption}
              </p>
              <p className="text-gray-400 text-xs md:text-sm text-center mt-1">
                Cliquez n'importe où pour fermer
              </p>
            </div>
          </div>
        </motion.div>
      )}

      {/* Sessions Live */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold mb-4">
              {t('worship.sessions.title')}
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              {t('worship.sessions.subtitle')}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {liveSessions.map((session, index) => (
              <motion.div
                key={session.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2 }}
                whileHover={{ y: -8 }}
                className={`bg-gradient-to-b from-gray-900/50 to-black/50 rounded-3xl p-6 border border-gray-800 hover:border-gray-700 transition-all duration-500 group ${
                  selectedEvent === index ? 'ring-2 ring-yellow-500/50' : ''
                }`}
                onClick={() => setSelectedEvent(index)}
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-yellow-600/20 to-yellow-800/20 rounded-xl flex items-center justify-center border border-yellow-500/30">
                      {session.icon}
                    </div>
                    <div className={`px-3 py-1 rounded-full text-sm font-medium ${
                      session.type === t('worship.sessions.coffee.type') 
                        ? 'bg-red-100 text-red-600 dark:bg-red-900 dark:text-red-300'
                        : session.type === t('worship.sessions.morning.type')
                        ? 'bg-blue-100 text-blue-600 dark:bg-blue-900 dark:text-blue-300'
                        : 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-400'
                    }`}>
                      {session.type}
                    </div>
                  </div>
                  <div className="flex items-center text-gray-400 text-sm">
                    <Clock className="w-4 h-4 mr-1" />
                    {session.duration}
                  </div>
                </div>

                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-yellow-600 transition-colors">
                  {session.title}
                </h3>

                <div className="flex items-center gap-4 mb-4 text-sm text-gray-400">
                  <div className="flex items-center">
                    <Calendar className="w-4 h-4 mr-1" />
                    {session.date}
                  </div>
                  <div className="flex items-center">
                    <Clock className="w-4 h-4 mr-1" />
                    {session.time}
                  </div>
                </div>

                <p className="text-gray-300 mb-6 leading-relaxed">
                  {session.description}
                </p>

                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center text-sm text-gray-400">
                    <Users className="w-4 h-4 mr-1" />
                    {t('worship.by')} {session.speaker}
                  </div>
                  {session.location && (
                    <div className="text-sm text-gray-400">
                      📍 {session.location}
                    </div>
                  )}
                </div>

                <div className="flex gap-3">
                  <a
                    href={session.youtubeLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 py-3 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white rounded-lg font-semibold hover:shadow-xl hover:shadow-yellow-500/20 hover:scale-105 transition-all duration-300 flex items-center justify-center"
                  >
                    <Play className="w-4 h-4 mr-2" />
                    {t('worship.buttons.watch')}
                  </a>
                  <a
                    href={session.youtubeLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 border border-gray-700 rounded-lg flex items-center justify-center hover:bg-gray-800 transition-colors"
                  >
                    <ExternalLink className="w-5 h-5" />
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Vidéothèque */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row lg:items-center justify-between mb-12">
            <div>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              >
                <h2 className="text-4xl font-bold text-white font-serif">
                  {t('worship.videos.title')}
                </h2>
                <p className="text-xl text-gray-400 mt-2">
                  {t('worship.videos.subtitle', { count: youtubeVideos.length })}
                </p>
              </motion.div>
            </div>
            
            {/* Pagination Controls */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="flex items-center gap-4 mt-6 lg:mt-0"
            >
              <button
                onClick={() => setCurrentVideoPage(prev => Math.max(1, prev - 1))}
                disabled={currentVideoPage === 1}
                className="p-3 rounded-xl border border-gray-700 hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              
              <div className="flex items-center gap-2">
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  const pageNum = Math.max(1, Math.min(totalPages - 4, currentVideoPage - 2)) + i
                  if (pageNum > totalPages) return null
                  return (
                    <button
                      key={pageNum}
                      onClick={() => setCurrentVideoPage(pageNum)}
                      className={`w-10 h-10 rounded-lg font-medium transition-all ${
                        currentVideoPage === pageNum
                          ? 'bg-yellow-700 text-white'
                          : 'border border-gray-700 hover:bg-gray-800'
                      }`}
                    >
                      {pageNum}
                    </button>
                  )
                })}
                {totalPages > 5 && currentVideoPage < totalPages - 2 && (
                  <>
                    <span className="text-gray-500">...</span>
                    <button
                      onClick={() => setCurrentVideoPage(totalPages)}
                      className="w-10 h-10 rounded-lg border border-gray-700 hover:bg-gray-800"
                    >
                      {totalPages}
                    </button>
                  </>
                )}
              </div>
              
              <button
                onClick={() => setCurrentVideoPage(prev => Math.min(totalPages, prev + 1))}
                disabled={currentVideoPage === totalPages}
                className="p-3 rounded-xl border border-gray-700 hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </motion.div>
          </div>

          {/* Videos Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {currentVideos.map((video, index) => (
              <motion.div
                key={`${video.id}-${index}`}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="bg-gradient-to-b from-gray-900/50 to-black/50 rounded-2xl overflow-hidden border border-gray-800 hover:border-gray-700 transition-all duration-300 group"
              >
                {/* YouTube Player */}
                <div className="relative aspect-video bg-gray-900">
                  <YouTube
                    videoId={video.id}
                    opts={opts}
                    onReady={onPlayerReady}
                    className="w-full h-full"
                  />
                  <div className="absolute bottom-3 right-3 bg-black/80 text-white px-2 py-1 rounded text-sm">
                    {video.duration}
                  </div>
                </div>

                {/* Video Info */}
                <div className="p-5">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                      <h3 className="font-bold text-white line-clamp-2 text-lg mb-1">
                        {video.title}
                      </h3>
                      <div className="flex items-center text-sm text-gray-400 mb-2">
                        <span className="text-yellow-600 font-medium">{video.channel}</span>
                        <span className="mx-2">•</span>
                        <span className="px-2 py-0.5 bg-yellow-500/10 text-yellow-600 rounded text-xs">
                          {video.category}
                        </span>
                      </div>
                    </div>
                    <button
                      onClick={() => toggleLike(video.id)}
                      className="ml-2 text-gray-400 hover:text-red-500 transition-colors"
                    >
                      <Heart className={`w-5 h-5 ${likedVideos[video.id] ? 'fill-red-500 text-red-500' : ''}`} />
                    </button>
                  </div>
                  
                  <p className="text-sm text-gray-300 mb-4 line-clamp-2">
                    {video.description}
                  </p>
                  
                  <div className="flex flex-wrap gap-2 mb-4">
                    {video.tags.map(tag => (
                      <span key={tag} className="px-2 py-1 bg-gray-800 text-gray-300 rounded text-xs">
                        #{tag}
                      </span>
                    ))}
                  </div>
                  
                  <div className="flex items-center justify-between text-sm text-gray-400 mb-5">
                    <div className="flex items-center">
                      <Eye className="w-4 h-4 mr-1" />
                      {video.views} {t('worship.views')}
                    </div>
                    <div>{video.date}</div>
                  </div>
                  
                  <div className="flex gap-3">
                    <button
                      onClick={() => handleVideoClick(video.id)}
                      className="flex-1 py-3 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white rounded-lg font-medium hover:shadow-lg hover:shadow-yellow-500/20 hover:scale-105 transition-all flex items-center justify-center"
                    >
                      <Play className="w-4 h-4 mr-2" />
                      {t('worship.buttons.watchYoutube')}
                    </button>
                    <button 
                      onClick={() => handleShareVideo(video.id, video.title)}
                      className="px-4 py-3 border border-gray-700 rounded-lg hover:bg-gray-800 transition-colors flex items-center justify-center"
                    >
                      <Share2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Page Info */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-center text-gray-500 pt-6 border-t border-gray-800"
          >
            {t('worship.pageInfo', {
              current: currentVideoPage,
              total: totalPages,
              start: (currentVideoPage - 1) * videosPerPage + 1,
              end: Math.min(currentVideoPage * videosPerPage, youtubeVideos.length),
              totalVideos: youtubeVideos.length
            })}
          </motion.div>
        </div>
      </section>

      {/* Calendrier */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-4xl font-bold mb-4">
              {t('worship.calendar.title')}
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              {t('worship.calendar.subtitle')}
            </p>
          </motion.div>

          <div className="bg-gradient-to-b from-gray-900/50 to-black/50 rounded-3xl p-8 border border-gray-800">
            {/* CALENDRIER GOOGLE EMBED */}
            <iframe 
              src="https://calendar.google.com/calendar/embed?src=esaiehostinger%40gmail.com&ctz=Africa%2FNairobi&hl=fr" 
              style={{ 
                border: 'none', 
                width: '100%', 
                height: '600px',
                borderRadius: '16px'
              }}
              className="border border-gray-700"
              frameBorder="0"
              scrolling="no"
            />
            
            <div className="mt-6 text-center space-y-4">
              <p className="text-gray-400 text-sm">
                {t('worship.calendar.instructions')}
              </p>
              
              {/* BOUTON ANDROID */}
              <a 
                href="https://calendar.google.com/calendar/render?cid=esaiehostinger%40gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-yellow-600 hover:bg-yellow-700 rounded-lg text-white font-medium transition-colors mx-auto"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.9 17.39c-.26-.8-1.01-1.39-1.9-1.39h-1v-3a1 1 0 0 0-1-1H8v-2h2a1 1 0 0 0 1-1V7h2a2 2 0 0 0 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39zM11 19.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.22.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93z"/>
                </svg>
                {t('worship.calendar.addToPhone')}
              </a>
              
              {/* Instructions détaillées */}
              <div className="mt-6 p-4 bg-gray-900/50 rounded-lg border border-gray-800">
                <h4 className="text-white font-medium mb-3">{t('worship.calendar.detailedInstructions')}:</h4>
                <div className="text-gray-400 text-sm space-y-3">
                  <div className="flex items-start gap-2">
                    <div className="bg-blue-600 rounded-full w-6 h-6 flex items-center justify-center text-xs mt-0.5">1</div>
                    <p>{t('worship.calendar.step1')}</p>
                  </div>
                  
                  <div className="flex items-start gap-2">
                    <div className="bg-blue-600 rounded-full w-6 h-6 flex items-center justify-center text-xs mt-0.5">2</div>
                    <p>{t('worship.calendar.step2')}</p>
                  </div>
                  
                  <div className="flex items-start gap-2">
                    <div className="bg-blue-600 rounded-full w-6 h-6 flex items-center justify-center text-xs mt-0.5">3</div>
                    <p>{t('worship.calendar.step3')}</p>
                  </div>
                  
                  <div className="flex items-start gap-2">
                    <div className="bg-blue-600 rounded-full w-6 h-6 flex items-center justify-center text-xs mt-0.5">4</div>
                    <p>{t('worship.calendar.step4')}</p>
                  </div>
                </div>
              </div>
              
              {/* Alternative manuelle */}
              <details className="mt-4 text-left">
                <summary className="text-gray-400 text-sm cursor-pointer hover:text-white">
                  🔧 {t('worship.calendar.manualTitle')}
                </summary>
                <div className="mt-2 p-3 bg-gray-900 rounded text-sm text-gray-300">
                  <p className="mb-2">{t('worship.calendar.manualStep1')}</p>
                  <p className="mb-2">{t('worship.calendar.manualStep2')}</p>
                  <p className="mb-2">{t('worship.calendar.manualStep3')}</p>
                  <p className="mb-2">{t('worship.calendar.manualStep4')}</p>
                  <code className="block p-2 bg-black rounded text-xs break-all">
                    https://calendar.google.com/calendar/ical/esaiehostinger%40gmail.com/public/basic.ics
                  </code>
                </div>
              </details>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="max-w-3xl mx-auto"
          >
            <div className="bg-gradient-to-br from-gray-900/50 to-black/50 rounded-3xl p-12 border border-gray-800 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-32 h-32 bg-yellow-500/10 rounded-full -translate-x-16 -translate-y-16"></div>
              <div className="absolute bottom-0 right-0 w-48 h-48 bg-yellow-500/10 rounded-full translate-x-24 translate-y-24"></div>
              
              <div className="relative z-10">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-600/20 to-yellow-800/20 rounded-2xl flex items-center justify-center border border-yellow-500/30 mx-auto mb-6">
                  <Film className="w-8 h-8 text-yellow-600" />
                </div>
                
                <h2 className="text-4xl font-bold text-white mb-6">
                  {t('worship.cta.title')}
                </h2>
                
                <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                  {t('worship.cta.description')}
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                  <a
                    href="https://youtube.com/@esaie_wilondja?si=5Wou6bCZ8Lide8cv"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-8 py-4 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-xl font-semibold hover:shadow-2xl hover:shadow-red-500/20 hover:scale-105 transition-all duration-300 flex items-center justify-center space-x-3"
                  >
                    <Play className="w-5 h-5" />
                    <span>{t('worship.cta.subscribeYoutube')}</span>
                  </a>
                  
                  <a
                    href="https://chat.whatsapp.com/CreU1H442qQBIg84iMXEHb?mode=hqrt2"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-8 py-4 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-xl font-semibold hover:shadow-2xl hover:shadow-green-500/20 hover:scale-105 transition-all duration-300 flex items-center justify-center space-x-3"
                  >
                    <Users className="w-5 h-5" />
                    <span>{t('worship.cta.whatsappGroup')}</span>
                  </a>
                </div>
                
                <p className="text-sm text-gray-500 mt-6">
                  {t('worship.cta.freeEvents')}
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  )
}

export default Worship